import { DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

import { CustomDialog } from 'src/components/CustomDialog';
import { NewProjectPromptWidget } from 'src/views/NewProjectPromptWidget';

import { useStyles } from './useStyles';

export const CreateContentPopup = ({ open, onClose }) => {
  const styles = useStyles();

  return (
    <CustomDialog
      className={styles.root}
      classes={{ title: styles.title }}
      open={open}
      onClose={onClose}
      title="What do you want to create?"
      data-testid="popupCreateContent"
      displayCloseIcon
      hideActions
    >
      <DialogContent className={styles.dialogContent}>
        <NewProjectPromptWidget
          className={styles.widget}
          onFlowFinished={onClose}
          inPopupMode
        />
      </DialogContent>
    </CustomDialog>
  );
};

CreateContentPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
CreateContentPopup.defaultProps = {};
